import type { RadioProps } from "@bluframe/blublocks"
import {
  Review,
  ReviewsServiceName
} from "@bluframe/mightychroma-mightytool-frontend-types"

import Reviews from "./Reviews"

export interface Props {
  readonly actions: React.ReactNode
  readonly avatar: string
  readonly display: Review[]
  readonly flagLoading: boolean
  readonly isShowFlagButton: boolean
  readonly onSelect: RadioProps["onChange"]
  readonly onToggleFlagged: (id: string, isFlagged: boolean) => () => void
  readonly selected: string
  readonly serviceName: ReviewsServiceName
  readonly subheader: string
  readonly title: string
}

export interface ComponentProps extends Props {}

export default Reviews
